import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";

import ViewInArIcon from '@mui/icons-material/ViewInAr';
import {MonetizationOnOutlined, FolderOutlined, AccountCircleOutlined, LockOutlined, LockOpen, StorageOutlined, BadgeOutlined, Fingerprint} from '@mui/icons-material';
//import {StorageOutlined} from '../icons/icons'

const requiredValue = (value, inverse) => {
    if (inverse) {
        switch (value) {
            case false:
                return 0;
            case true:
                return 1;
            default:
                return 2;
        }
    }

    switch (value) {
        case true:
            return 0;
        case false:
            return 1;
        default:
            return 2;
    }
};

const colorClasses = ['green-icon', 'grey-icon', 'orange-icon'];

const access = ['Controlled Access Option', 'No Controlled Access Option', 'Unclear Access Controls'];
const metadata = ['Metadata Required', 'No Metadata Required', 'Unclear Metadata Requirements'];
const dataLimited = ['Data Volume Limitations', 'No Data Volume Limitations', 'Unclear Data Volume Limitations'];
const individual = ['Accepts Individual-Level Data', 'Does Not Accept Individual-Level Data', 'Unclear if Accepts Individual Level Data'];
const persistentId = ['Persistent ID Used for Datasets', 'No Persistent ID Used', 'Unclear if Persistent ID Used'];
const cost = ['Fee for Submission', 'No Fee for Submission', 'Unclear if Fee for Submission'];
const deidentification = [ 'Requires Specific De-Identification Method',  'Not Applicable (No Human Data Accepted)', 'No De-Identification Requirements Specified'];
const generalist = ['Domain Specific', 'Generalist'];

const QuickView = ({ repository, split=false, ...props }) => {
    // console.log(props);
    const gridSize = split ? 6 : 12;

    return ( <React.Fragment>
        <Grid container spacing={1}>
            <Grid xs={gridSize}
                    display="flex"
                    alignItems="center"
            >
                {requiredValue(repository['data_access_controlled']) === 0 &&
                    <LockOutlined className={'green-icon'} />
                }
                {requiredValue(repository['data_access_controlled']) === 1 &&
                    <LockOpen className={'green-icon'} />
                }
                {requiredValue(repository['data_access_controlled']) === 2 &&
                    <LockOpen className={'orange-icon'} />
                }

                <Typography className='repository-card-info-note'>
                    {access[requiredValue(repository['data_access_controlled'])]}
                </Typography>
            </Grid>

            <Grid xs={gridSize}
                    display="flex"
                    alignItems="center"
            >
                <FolderOutlined className={colorClasses[requiredValue(repository['metadata_required'])]} />
                <Typography className='repository-card-info-note'>
                    {metadata[requiredValue(repository['metadata_required'])]}
                </Typography>
            </Grid>

            <Grid xs={gridSize}
                    display="flex"
                    alignItems="center"
            >
                <StorageOutlined className={colorClasses[requiredValue(repository['data_volume_limited'], true)]} />
                <Typography className='repository-card-info-note'>
                    {dataLimited[requiredValue(repository['data_volume_limited'])]}
                </Typography>
            </Grid>

            <Grid xs={gridSize}
                    display="flex"
                    alignItems="center"
            >
                <AccountCircleOutlined className={colorClasses[requiredValue(repository['accepts_individual_data'])]} />
                <Typography className='repository-card-info-note'>
                    {individual[requiredValue(repository['accepts_individual_data'])]}
                </Typography>
            </Grid>

            <Grid xs={gridSize}
                    display="flex"
                    alignItems="center"
            >
                <BadgeOutlined className={colorClasses[requiredValue(repository['persistent_id_used'])]} />
                <Typography className='repository-card-info-note'>
                    {persistentId[requiredValue(repository['persistent_id_used'])]}
                </Typography>
            </Grid>

            <Grid xs={gridSize}
                    display="flex"
                    alignItems="center"
            >
                <MonetizationOnOutlined className={colorClasses[requiredValue(repository['cost_to_submit'], true)]} />
                <Typography sx={{textAlign: 'center'}} className='repository-card-info-note'>
                    {cost[requiredValue(repository['cost_to_submit'])]}
                </Typography>
            </Grid>

            <Grid xs={gridSize}
                    display="flex"
                    alignItems="center"
            >
                {requiredValue(repository['requires_deidentified_data']) === 0 &&
                    <Fingerprint className={'green-icon'} />
                }
                {requiredValue(repository['requires_deidentified_data']) === 1 &&
                    <Fingerprint className={'green-icon'} />
                }
                {requiredValue(repository['requires_deidentified_data']) === 2 &&
                    <Fingerprint className={'orange-icon'} />
                }

                <Typography className='repository-card-info-note'>
                     {deidentification[requiredValue(repository['requires_deidentified_data'])]}
                </Typography>
            </Grid>



            <Grid xs={gridSize}
                    display="flex"
                    alignItems="center"
                    >
                <ViewInArIcon className={colorClasses[requiredValue(repository['generalist'], true)]} />
                <Typography sx={{textAlign: 'center'}} className='repository-card-info-note'>
                    {generalist[requiredValue(repository['generalist'], true)]}
                </Typography>
            </Grid>
        </Grid>
    </React.Fragment> );
}

export default QuickView;